import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Popper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';
import './NavMiniFlyout.css';

const CLOSE_DELAY_MS = 150;

const NavCollapsedTitle = ({ show, title, children }) => {
  const anchorRef = useRef(null);
  const closeTimerRef = useRef(null);
  const [flyoutOpen, setFlyoutOpen] = useState(false);

  const clearCloseTimer = () => {
    if (closeTimerRef.current) {
      window.clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  };

  useEffect(() => () => clearCloseTimer(), []);

  if (!show || !title) {
    return children;
  }

  const handleMouseEnter = () => {
    clearCloseTimer();
    setFlyoutOpen(true);
  };

  const handleMouseLeave = () => {
    clearCloseTimer();
    closeTimerRef.current = window.setTimeout(() => {
      setFlyoutOpen(false);
    }, CLOSE_DELAY_MS);
  };

  const menuItem = React.isValidElement(children)
    ? React.cloneElement(children)
    : children;

  return (
    <React.Fragment>
      <span
        ref={anchorRef}
        className="nav-collapsed-title-wrap"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </span>
      <Popper
        open={flyoutOpen}
        anchorEl={anchorRef.current}
        placement="right-start"
        strategy="fixed"
        disablePortal={false}
        container={typeof document !== 'undefined' ? document.body : undefined}
        modifiers={[
          {
            name: 'offset',
            options: { offset: [0, 8] },
          },
          {
            name: 'preventOverflow',
            options: { padding: 8, altAxis: true },
          },
          {
            name: 'flip',
            enabled: true,
          },
        ]}
        style={{ zIndex: 1500 }}
      >
        <Paper
          className="nav-mini-flyout-panel"
          elevation={8}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          sx={{
            minWidth: 220,
            maxWidth: 400,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div className="nav-mini-flyout-title">{title}</div>
          <div className="nav-mini-flyout-body">{menuItem}</div>
        </Paper>
      </Popper>
    </React.Fragment>
  );
};

NavCollapsedTitle.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.node,
  children: PropTypes.node,
};

NavCollapsedTitle.defaultProps = {
  show: false,
  title: '',
};

export default NavCollapsedTitle;



// WEBPACK FOOTER //
// ./src/components/leftnav/NavCollapsedTitle.js